define('GameDayCore/GDModel/ValueObjects/Players/PlayerFileItem',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
    var VO = require('../ValueObjectFactory');

    VO.create(PlayerFileItem);

    /**
     * @class PlayerFileItem
     * @param data {Object} json object of individual player passed down from the PlayerFile VO
     */
    function PlayerFileItem($data,$homeAway) {
        var vo = VO.ensureVO(this, PlayerFileItem),
            data = $data;

        vo.id = data.id || "";
        vo.first = data["first"] || "";
        vo.last = data["last"] || "";
        vo.num = data.num || "";
        vo.boxname = data.boxname || "";
        vo.rl = data.rl || "";
        vo.position = data.position || "";
        vo.status = data.status || "";
        vo.avg = data.avg || "";
        vo.hr = data.hr || "";
        vo.rbi = data.rbi || "";
        vo.wins = data.wins || "";
        vo.losses = data.losses || "";
        vo.era = data.era || "";
        vo.parent_team_id = data.parent_team_id || "";
        vo.parent_team_abbrev = data.parent_team_abbrev || "";
        vo.isHome = ($homeAway === "home");
        vo.isAway = ($homeAway === "away");
    }

    return PlayerFileItem;
});

